import type { SubmissionAction } from '@/classes/SubmissionStatuses/types'
import type { SubmissionChannel } from '@/services/types'
import { useSubmissionStore } from '@/stores/submission'

export default class RetryAction implements SubmissionAction {
	buttonText = 'Retry'

	constructor(private channels: SubmissionChannel[]) {}

	async onClick(planId: string) {
		const submissionStore = useSubmissionStore()

		await submissionStore.retryByPlanHolderId(planId, this.channels)
	}
}
